import type { DateTime } from "luxon";
import type { ReactNode } from "react";
import { AgencyUseChart } from "./visualizers/AgencyUseChart";
import { HPPDComparison } from "./visualizers/HPPDComparison";
import { OTUseChart } from "./visualizers/OTUseChart";
import { PPDComparison } from "./visualizers/PPDComparison";
import { ShiftFillRateChart } from "./visualizers/ShiftFillRateChart";
import { StaffSatisfactionChart } from "./visualizers/StaffSatisfactionChart";
import { WeekActiveUsersChart } from "./visualizers/WeekActiveUsersChart";

export type ManagementCenterChartKey = "ppdComparison" | "hppdComparison" | "staffSatisfaction" | "shiftFillRate" | "otUse" | "agencyUse" | "weekActiveUsers";

export const ALL_CHARTS: {
	id: ManagementCenterChartKey;
	render: (
		maxRows: number,
		width: string,
		selectedRegions: string[],
		handleItemDoubleClick: (departmentName: string) => void,
		startDate: DateTime,
		endDate: DateTime,
	) => ReactNode;
}[] = [
	{
		id: "ppdComparison",
		render: (maxRows, width, selectedRegions, handleItemDoubleClick, startDate, endDate) => (
			<PPDComparison
				key="ppdComparison"
				maxRows={maxRows}
				width={width}
				selectedRegions={selectedRegions}
				handleItemDoubleClick={handleItemDoubleClick}
				startDate={startDate}
				endDate={endDate}
			/>
		),
	},
	{
		id: "hppdComparison",
		render: (maxRows, width, selectedRegions, handleItemDoubleClick, startDate, endDate) => (
			<HPPDComparison
				key="hppdComparison"
				maxRows={maxRows}
				width={width}
				selectedRegions={selectedRegions}
				handleItemDoubleClick={handleItemDoubleClick}
				startDate={startDate}
				endDate={endDate}
			/>
		),
	},
	{
		id: "staffSatisfaction",
		render: (maxRows, width, selectedRegions, handleItemDoubleClick, startDate, endDate) => (
			<StaffSatisfactionChart
				key="staffSatisfaction"
				maxRows={maxRows}
				width={width}
				selectedRegions={selectedRegions}
				handleItemDoubleClick={handleItemDoubleClick}
				startDate={startDate}
				endDate={endDate}
			/>
		),
	},
	{
		id: "shiftFillRate",
		render: (maxRows, width, selectedRegions, handleItemDoubleClick, startDate, endDate) => (
			<ShiftFillRateChart
				key="shiftFillRate"
				maxRows={maxRows}
				width={width}
				selectedRegions={selectedRegions}
				handleItemDoubleClick={handleItemDoubleClick}
				startDate={startDate}
				endDate={endDate}
			/>
		),
	},
	{
		id: "otUse",
		render: (maxRows, width, selectedRegions, handleItemDoubleClick, startDate, endDate) => (
			<OTUseChart
				key="otUse"
				maxRows={maxRows}
				width={width}
				selectedRegions={selectedRegions}
				handleItemDoubleClick={handleItemDoubleClick}
				startDate={startDate}
				endDate={endDate}
			/>
		),
	},
	{
		id: "agencyUse",
		render: (maxRows, width, selectedRegions, handleItemDoubleClick, startDate, endDate) => (
			<AgencyUseChart
				key="agencyUse"
				maxRows={maxRows}
				width={width}
				selectedRegions={selectedRegions}
				handleItemDoubleClick={handleItemDoubleClick}
				startDate={startDate}
				endDate={endDate}
			/>
		),
	},
	{
		id: "weekActiveUsers",
		render: (maxRows, width, selectedRegions, handleItemDoubleClick, startDate, endDate) => (
			<WeekActiveUsersChart
				key="weekActiveUsers"
				maxRows={maxRows}
				width={width}
				selectedRegions={selectedRegions}
				handleItemDoubleClick={handleItemDoubleClick}
				startDate={startDate}
				endDate={endDate}
			/>
		),
	},
] as const;
